<template>
  <div id="login">
    <div class="loginBox">
      <h2>数据分析系统</h2>
      <el-form :model="user" :rules="loginRules" class="demo-ruleForm">
        <div style="height:20px;"></div>
        <el-form-item prop="account">
          <el-input v-model="user.account" name="account" type="text" clearable placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item prop="pwd">
          <el-input v-model="user.pwd" name="pwd" type="password" clearable placeholder="请输入密码"
            @keyup.enter.native="login">
          </el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="login">登&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;录</el-button>
    </div>
  </div>
</template>

<script>
import {
  setCookie, setSessionStore, removeSessionStore
} from '@/common/common'
export default {
  name: "login",
  data () {
    return {
      user: {
        account: '',
        pwd: ''
      },
      loginRules: {
        account: [{
          required: true,
          message: "请输入用户名",
          trigger: "blur"
        }],
        pwd: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }]
      }
    }
  },
  methods: {
    login () {
      if (this.user.account == 'admin' && this.user.pwd == 'chongshi123..@') {
        this.$router.push({
          name: 'home'
        })
        setSessionStore('SignIn', 'ok')
      } else {
        this.$message.error("用户名或密码错误")
        this.$router.push({
          name: 'login'
        })
      }
    }
    // login() {
    //   this.loading = true;
    //   if (this.user.account == '' || this.user.pwd == '') {
    //     this.$message.error("请输入正确的用户名和密码");
    //   }
    //   api.logins({
    //     phoneNo: this.user.account,
    //     password: this.user.pwd
    //   }).then(res => {
    //     this.loading = false;
    //     if (res.status == "200") {
    //       setCookie('JSESSIONID', res.token, 7);
    //       if (res.num == "0") {
    //         this.$router.push({
    //           path: '/home/configuration',
    //           query: {
    //             nums: res.num
    //           }
    //         })
    //       } else {
    //         this.$router.push({
    //           path: './home',
    //           query: {
    //             nums: res.num,
    //             ok: true
    //           }
    //         })
    //       }
    //     } else {
    //       this.$message.error(res.result)
    //     }
    //   })
    // }
  }
}
</script>

<style scoped lang="scss">
#login {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-width: 800px;
  min-height: 698px;
  background: url("../assets/bg.jpg") no-repeat center;
  background-size: 100% 100%;

  .loginBox {
    width: 580px;
    height: 400px;
    background: rgba($color: #fefefe, $alpha: 0.7);
    margin: 0 auto;
    margin-top: 12%;

    h2 {
      color: #06263f;
      padding-top: 35px;
      letter-spacing: 5px;
      font-size: 220%;
      text-align: center;
    }

    .el-form {
      width: 70%;
      margin: 0 auto;
    }

    .el-input {
      margin-top: 10px;
      font-size: 16px;
    }

    .el-button {
      width: 70%;
      font-size: 20px;
      margin: 0 auto;
      margin-top: 18px
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/login.vue